import { ReadMoreAccordion as UiReadMoreAccordion } from 'macaron-frontend-ui'
import type { ComponentProps } from 'react'

type Props = ComponentProps<typeof UiReadMoreAccordion>
const ReadMoreAccordion: React.FC<Props> = ({ ...props }: Props) => (
  <UiReadMoreAccordion {...props} />
)

export default ReadMoreAccordion
